"use strict";
Object.defineProperty(exports, "__esModule", { value: true });
var generatedConstants_1 = require("./generatedConstants");
var isRemoteVectorImageFormatExtension = function (extension) { return generatedConstants_1.remoteVectorImageFormatExtensions.includes(extension); };
exports.default = isRemoteVectorImageFormatExtension;
